<template>
  <div class="app-wrapper">
    <div class="main-container">
      <app-main></app-main>
    </div>
    <tabbar></tabbar>
  </div>
</template>

<script>
import { Navbar, AppMain, Tabbar } from './components'

export default {
  name: 'layout',
  components: {
    Navbar,
    AppMain,
    Tabbar
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "src/styles/mixin.scss";
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
  background-color: #f2f2f2;
  .main-container {
    height: 100%;
    width: 100%;
    overflow-y: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/layout.vue